import React, { Component } from "react";
import CallList from "./CallList";
import CallTranscript from "./CallTranscript";

class Calls extends Component {
  render() {
    return (
      <div
        className="w-full h-screen p-4 flex gap-4 overflow-hidden"
        style={{
          background:
            "radial-gradient(ellipse at top left, #dbeafe 0%, transparent 50%), radial-gradient(ellipse at top right, #e0e7ff 0%, transparent 50%), radial-gradient(ellipse at bottom center, #eff6ff 0%, transparent 60%), #f8faff",
        }}
      >
        <CallList />
        <CallTranscript />
      </div>
    );
  }
}

export default Calls;
